export const PORTAL_IMAGE_TELEMETRY_EVENT = "ecotour:telemetry";

const safeText = (value = "") => String(value || "").trim();

export const buildPortalImageTelemetryDetail = (event, plan = {}, extra = {}) => ({
  event: safeText(event),
  contractVersion: safeText(plan.contractVersion),
  surfaceKey: safeText(plan.surfaceKey),
  slotKey: safeText(plan.slotKey),
  presetKey: safeText(plan.presetKey),
  viewport: safeText(plan.viewport),
  source: safeText(plan.source),
  migrationState: safeText(plan.migrationState),
  integrityStatus: safeText(plan.integrityStatus),
  missingVariant: Boolean(plan.missingVariant),
  rolloutStage: safeText(plan.rollout?.stage),
  rolloutReason: safeText(plan.rollout?.reason),
  legacyFallbackAllowed: plan.rollout?.legacyFallbackAllowed !== false,
  fallbackDecisionReason: safeText(plan.rollout?.fallbackDecisionReason),
  optimized: Boolean(plan.optimized),
  ...extra,
});

export const emitPortalImageTelemetry = (event, plan = {}, extra = {}) => {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return false;
  if (plan.rollout?.telemetryEnabled === false) return false;
  const detail = buildPortalImageTelemetryDetail(event, plan, extra);
  if (!detail.event) return false;
  window.dispatchEvent(new CustomEvent(PORTAL_IMAGE_TELEMETRY_EVENT, { detail }));
  return true;
};

export default emitPortalImageTelemetry;
